export const RadarLoader = ({ company }) => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center gap-6">
    <div className="radar-sweep" />
    <div className="text-center">
      <div className="kpi-label text-[#0A84FF] mb-2">/ COMPILING INTELLIGENCE</div>
      <div className="font-display text-2xl text-white tracking-tight">{company || "Account"}</div>
      <div className="text-sm text-[#A3A3A3] mt-2 max-w-md mx-auto">
        Claude Sonnet 4.5 is analyzing 21 sections — financials, strategy, deal opportunities, leadership and outreach drafts.
      </div>
      <div className="mt-4 flex items-center justify-center gap-2 text-[11px] text-[#525252] font-mono-data">
        <span className="w-1.5 h-1.5 rounded-full bg-[#0A84FF] animate-pulse" />
        <span>Estimated 60-90 seconds</span>
      </div>
    </div>
  </div>
);

export default RadarLoader;
